import { render, staticRenderFns } from "./BalanceAccount.vue?vue&type=template&id=5bbd7094&"
import script from "./BalanceAccount.vue?vue&type=script&lang=js&"
export * from "./BalanceAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports